<template src="./html/sandbox-form.html"></template>

<style lang="scss" src="./styles/main.scss"></style>

<i18n src="./i18n/i18n.json"></i18n>

<script>
import Vue from "vue";
import "es6-promise/auto";
import "owl.carousel";
import axios from "axios";
import lodash from "lodash";
import VueCookies from "vue-cookies";
import VueMeta from "vue-meta";

import browserDetect from "vue-browser-detect-plugin";

import VeeValidate from "vee-validate";
import { setTimeout } from "timers";

import { validation_dict } from "./i18n/validation.js";
import { submit } from "./exports/methods/submit.js";
import { send } from "./exports/methods/send.js";
import { sso } from "./exports/methods/sso.js";
import { poll_results } from "./exports/methods/pollResults.js";
import { computedFunctions } from "./exports/computedFunctions.js";
import { emailChecks } from "./exports/methods/emailChecks.js";
import { sandboxes } from "./exports/sandboxes.js";
import { deepMerge } from "./exports/deepMerge.js";

const config = {
  dictionary: validation_dict
};

Vue.use(VeeValidate, config);
Vue.use(VueCookies);
Vue.use(browserDetect);
VueCookies.config("2h");
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

export default {
  data() {
    return {
      remote_server: "",
      hero_segment: "",
      post: {
        title: { rendered: "" },
        content: { rendered: "" },
        hero_image: { guid: "" }
      },
      bottom_post: { title: { rendered: "" }, content: { rendered: "" } },
      legal: { content: { rendered: "" } },
      step_1: true,
      loginURL: "https://trial.brightspace.com/",
      checkedEmail: false,
      sandbox: {
        color: "#000000",
        theme_color: "color-green",
        meta_title: "Try Brightspace FREE for 30 days",
        form_heading: "Experience Brightspace for yourself!",
        submit_button: "Create my sandbox",
        sfdc: "",
        fields: {
          email: {
            label: "Email",
            placeholder: "",
            freedomains: false
          },
          title: {
            label: "Job Title",
            placeholder: ""
          },
          role: false,
          marketing: false,
          interest: false,
          checkboxes: false
        },
        contentIds: {
          title: false,
          top: process.env.EN_SANDBOX_ID,
          bottom: process.env.EN_SANDBOX_BELOW_ID,
          legal: process.env.EN_LEGAL_ID
        }
      },
      formdata: {
        env: process.env.NODE_ENV,
        marketing: false,
        workflow: "default",
        firstname: { value: "", autofilled: false },
        lastname: { value: "", autofilled: false },
        email: { value: "", autofilled: false },
        phone: { value: "", autofilled: false },
        segment__c: { value: "", autofilled: false },
        industry: { value: "", autofilled: false },
        usecase: { value: "", autofilled: false, zoominfo: false },
        numOf: { value: "", autofilled: false },
        company: { value: "", autofilled: false },
        account: { value: "", autofilled: false },
        country: { value: "", autofilled: false },
        state: { value: "", autofilled: false },
        terms: { value: "", autofilled: false },
        consent: { value: "", autofilled: false },
        region: { value: "en", autofilled: false },
        locale: { value: "", autofilled: false },
        title: { value: "", autofilled: false },
        interest: { value: "", autofilled: false },
        interest_other: { value: "", autofilled: false },
        customer: { value: "" },
        utm_campaign: { value: "", autofilled: false },
        checkboxes: [],
        curriculum: {
          principal: "",
          grade: ""
        },
        sfdc: "",
        client_id: "",
        gclid: "",
        progressive: 0,
        password: ""
      },
      zoominfoData: {
        run: false
      },
      showPassword: false,
      confirmPassword: "",
      maxWaitTime: 80,
      tryNowCreated: "",
      response: [],
      responseError: "",
      errorMessage: "",
      loading: false,
      corpThanks: false,
      isIE: false,
      isStudent: false,
      hasTrackingProtection: false,
      showMessage: 0,
      loadingProgress: 0,
      loadingTime: 90,
      loadingMessages: [
        { message: "loading" },
        { message: "fact1" },
        { message: "fact2" },
        { message: "fact3" },
        { message: "fact4" },
        { message: "fact5" },
        { message: "fact6" },
        { message: "fact7" },
        { message: "fact8" },
        { message: "fact9" },
        { message: "fact10" },
        { message: "fact11" },
        { message: "fact12" },
        { message: "done" }
      ]
    };
  },
  metaInfo() {
    return {
      title: this.sandbox.meta_title
    };
  },
  mixins: [submit, send, poll_results, sso, emailChecks, computedFunctions],
  // Fetches posts when the component is created.
  created() {
    const self = this;

    this.isIE = this.$browserDetect.isIE;

    const region = this.$route.params.lang || "en";

    this.$i18n.locale = region;
    this.$i18n.fallbackLocale = "en";

    this.formdata.locale.value = this.$i18n.locale;
    this.$validator.localize(this.$i18n.locale);
    this.formdata.locale.value = this.$i18n.locale;

    this.formdata.region.value =
      this.$route.params.lang || this.formdata.locale.value;

    this.form_heading = this.$t("labels.header1");

    if (!sandboxes[this.$route.params.sandbox]) {
      // Check sandbox route is a valid one in the sandboxes list. If not send them to the generic try now.
      this.$router.push({ name: "brightspace" });
    }

    this.sandbox = deepMerge(
      this.sandbox,
      sandboxes[this.$route.params.sandbox]
    ); // Merges the default sandbox data structure with the customized object for the specified sandbox

    let pageId = "";

    this.formdata.workflow = this.$route.params.sandbox;

    this.formdata.email.value = this.sandbox.fields.email.placeholder;
    this.formdata.segment__c.value = this.sandbox.segment;
    this.formdata.sfdc = this.sandbox.sfdc;
    this.formdata.marketing = this.sandbox.fields.marketing;

    for (const [key, field] of Object.entries(this.sandbox.fields)) {
      if (
        key !== "email" &&
        typeof field === "object" &&
        field.hasOwnProperty("value")
      ) {
        self.formdata[key].value = field.value;
      }
    }

    this.hero_segment = this.$route.params.segment; // Hero segment used for the color of the main hero

    if (this.$route.query.h2 !== undefined) {
      this.form_heading = this.$route.query.h2; // replace form heading with dynamic content
    }

    if (process.env.NODE_ENV === "production") {
      if (window.location.host === "try.d2l.com") {
        this.remote_server = "https://www1.d2l.com";
      } else {
        this.remote_server = "https://d2lcorpdev.wpengine.com";
      }
    } else {
      this.remote_server = "https://d2l.local";
    }

    if (pageId === "") {
      if (typeof this.sandbox.contentIds === "object") {
        pageId = this.sandbox.contentIds.top;
      }
    }

    axios
      .get(process.env.JSON_LOCATION)
      .then(response => {
        // replace dynamic content
        if (this.$route.query.h1 !== undefined) {
          response.data.title.rendered = this.$route.query.h1;
        }
        else if (this.sandbox.contentIds.title !== false) {
          response.data.title.rendered = this.sandbox.contentIds.title;
        }

        this.post = response.data;
      })
      .catch(e => {
        this.errors.push(e);
      });

    if (this.$i18n.locale === "en") {
      pageId = this.sandbox.contentIds.bottom;

      axios
        .get(process.env.JSON_LOCATION)
        .then(response => {
          // JSON responses are automatically parsed.
          this.bottom_post = response.data;
          setTimeout(() => {
            let customCarousels = $(".custom-carousel");
            //console.log(customCarousels);
            if (customCarousels.length) {
              customCarousels.each(function() {
                var $items =
                  $(this).data("items") !== ""
                    ? parseInt($(this).data("items"))
                    : 1;
                var $margin = $items > 1 ? 0 : 10;
                var $nav = $(this).data("nav") === true ? true : false;
                var $dots = $(this).data("dots") === true ? true : false;
                var $autoplay =
                  $(this).data("autoplay") === true ? true : false;
                var $loop = $(this).data("loop") === false ? false : true;
                var $slideBy =
                  $(this).data("slideBy") !== ""
                    ? $(this).data("slideBy")
                    : "page";

                var carousel = $(this).find(".owl-carousel");
                carousel.owlCarousel({
                  loop: $loop,
                  items: $items,
                  dots: $dots,
                  margin: $margin,
                  autoplay: $autoplay,
                  autoplayHoverPause: true,
                  nav: $nav,
                  lazyload: true,
                  slideBy: $slideBy,
                  responsiveClass: true,
                  responsive: {
                    0: {
                      items: 1,
                      nav: false
                    },
                    768: {
                      items: $items > 1 ? 2 : 1
                    },
                    992: {
                      items: $items
                    }
                  },
                  afterAction: function() {
                    //console.log(this.itemsAmount+" - "+this.visibleItems.length);
                    if (this.itemsAmount > this.visibleItems.length) {
                      $(".next").removeAttr("disabled");
                      $(".prev").removeAttr("disabled");
                      if (this.currentItem == 0) {
                        $(".prev").attr("disabled");
                      }
                      if (this.currentItem == this.maximumItem) {
                        $(".next").attr("disabled");
                      }
                    }
                  }
                });

                $(this)
                  .find(".carousel-control--next")
                  .click(function(event) {
                    event.preventDefault();
                    carousel.trigger("next.owl.carousel");
                  });
                $(this)
                  .find(".carousel-control--prev")
                  .click(function(event) {
                    event.preventDefault();
                    carousel.trigger("prev.owl.carousel");
                  });

                if ($(this).hasClass("journey-carousel")) {
                  carousel.on("changed.owl.carousel", function(event) {
                    let pageSize = event.page.size,
                      itemCount = event.item.count,
                      itemIndex = event.item.index;

                    $(".journey-list .carousel-control button").removeAttr(
                      "disabled"
                    );
                    if (itemCount - itemIndex === pageSize) {
                      $(".journey-list .carousel-control--next").attr(
                        "disabled",
                        "disabled"
                      );
                    } else if (itemIndex === 0) {
                      $(".journey-list .carousel-control--prev").attr(
                        "disabled",
                        "disabled"
                      );
                    }
                  });
                }
              });
            }
          }, 100);
        })
        .catch(e => {
          this.errors.push(e);
        });
    }

    if (typeof localStorage.getItem("formData") === "string") {
      const savedData = JSON.parse(atob(localStorage.getItem("formData")));

      for (var key in savedData) {
        const temp_form_data = this.formdata[key];
        if (typeof temp_form_data !== "undefined" && key !== "segment__c") {
          temp_form_data.value = savedData[key];
          temp_form_data.autofilled = true;

          if (
            key !== "firstname" &&
            key !== "lastname" &&
            key !== "email" &&
            key !== "accept" &&
            key !== "utm_campaign"
          )
            this.formdata.progressive += 1;
        }
        //this.formdata[key]['value'] = savedData[key];
      }
    }

    if (typeof this.$route.query.utm_campaign !== "undefined") {
      this.formdata.utm_campaign.value = this.$route.query.utm_campaign;
      if (!self.$cookies.isKey("utm_campaign")) {
        self.$cookies.set(
          "utm_campaign",
          this.formdata.utm_campaign.value,
          "3y",
          "",
          process.env.COOKIE_DOMAIN
        );
      }
      self.$cookies.set(
        "utm_campaign_lt",
        this.formdata.utm_campaign.value,
        "14d",
        "",
        process.env.COOKIE_DOMAIN
      );
    }

    if (typeof this.$route.query.campaign !== "undefined") {
      this.formdata.sfdc = this.$route.query.campaign;
    }

    if (typeof this.$route.query.gclid !== "undefined") {
      this.formdata.gclid = this.$route.query.gclid;
    }

    pageId = this.sandbox.contentIds.legal;

    axios
      .get(process.env.JSON_LOCATION)
      .then(response => {
        // JSON responses are automatically parsed.
        this.legal = response.data;
      })
      .catch(e => {
        this.errors.push(e);
      });
  },
  mounted() {
    // Mounted runs after the DOM has been mounted. So you can make changes to it.
    const self = this;
    setTimeout(function() {
      // Helps to hide the changes during the test
      document.body.style.visibility = "visible";
    }, 200);

    let marketo_form_id = process.env.MARKETO_FORM_ID;

    if (this.$route.params.sandbox === 'masterclass') {
      marketo_form_id = process.env.MASTERCLASS_FORM_ID;
    }

    if (typeof MktoForms2 === "object") {
      document.getElementById("mktformPlaceholder").innerHTML = `<form id="mktoForm_${marketo_form_id}" style="display:none"></form>`;
      MktoForms2.loadForm("//app-sj27.marketo.com", process.env.MARKETO_INSTANCE_ID, marketo_form_id);
    }


    if (typeof self.$route.query.e !== "undefined") {
      self.formdata.email.value = self.$route.query.e;
      self.emailBlurred();
    }

    if (typeof ga !== "undefined") {
      // Get the GA client ID to send to marketo
      // We can't just go and grab the Cookie, so we need GA to do this.
      ga("create", {
        trackingId: "UA-52032323-1",
        cookieDomain: "auto",
        allowLinker: "true"
      });

      ga(function(tracker) {
        self.formdata.client_id = tracker.get("clientId");
      });
    }
  },
  methods: {
    fakeSubmit: function(event) {
      return;
    },
    setFocus(el) {
      setTimeout(() => {
        el.focus();
      }, 10);
    },
    hasError(type, error, location, messageChanger) {
      const self = this;

      // remove the password information so it's not logged anywhere.
      self.formdata.password = "";
      // Log the error data to a file for later use
      axios
        .post(
          self.remote_server + process.env.ERROR_URL,
          "\n" +
            new Date().toLocaleString() +
            " - " +
            error +
            " - " +
            location +
            "\n" +
            JSON.stringify(self.$browserDetect) +
            "\n" +
            JSON.stringify(self.formdata)
        )
        .catch(e => {
          console.log("more errors");
        });

      if (typeof error.message === "string") {
        error = error.message;
      }

      if (location === "MKTO") {
        return;
      }

      if (
        error.indexOf("addHiddenFields") !== -1 ||
        error.indexOf("mktoForm") !== -1
      ) {
        // Have to check this with actual marketo error
        self.poll_results(); // Go right to polling if Marketo fails. We want to keep them signed in.
      } else {
        if (location === "SSO 1" || location === "SSO 2") {
          self.errorMessage = `Oops! You're account was created but an error occurred when logging you in. Using your email and password you can manually login at <a href='${self.loginURL}'>${self.loginURL}</a>.`;
        } else {
          self.errorMessage = self.$t("tryAgain");
        }

        clearInterval(messageChanger);
        self.responseError = self.response.error;
        self.loading = false;
        self.loadingProgress = 0;
        self.showMessage = 0;
      }
    },
    validateBeforeSubmit(event) {
      const self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line

          self.submit(event);
          return;
        }
      });
    },
    nextStep() {
      const self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          self.step_1 = false;
          return;
        }
      });
    },
    hasValue: value => {
      if (typeof value === "string") return value.length;

      return 0;
    },
    resetUseCase() {
      this.formdata.usecase.value = "";
    },
    interest_change: function(value) {
      const self = this;

      // delay until the element is on the page
      setTimeout(() => {
        switch (self.formdata.interest.value) {
          case "student":
            self.isStudent = true;
            dataLayer.push({
              event: "trial-role-change",
              "role-name": self.formdata.interest.value
            });
            break;
          case "Other":
            self.$refs.interest_other.focus();
            break;
          default:
            self.isStudent = false;
            break;
        }
      }, 10);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sandbox-form.vue